import type { Core } from 'chessboard/core/config/types';
import type { API as ChessboardAPI } from 'chessboard/api/config/types';
import type { Modes } from 'chessboard/modes/config/types';
import type { PluginOverride } from 'api/override-api';

export namespace Plugins {
  export interface API {
    add: (plugins: Plugins.Model | Plugins.Model[]) => void;
    addMany: (plugins: Plugins.Model[]) => void;
    get: () => Plugins.Model[];
    has: (name: string) => boolean;
    remove: (key: string) => void;
    setCreatePluginContext: (context: Core.Context) => void;
  }

  export type Destroy = (...params: any) => void;

  export interface Match {
    handler: (event: Core.Event, context: Core.Context) => void;
    condition: (event: Core.Event, context: Core.Context) => boolean;
  }

  export interface BeforeState extends Match {
    /**
     * Should return `true` if event requires state
     * and `false` otherwise
     */
    handler: (event: Core.Event, context: Core.Context) => boolean;
  }

  export enum LogCodes {
    CreateFailure = 'CreateFailure',
  }

  export interface Model {
    afterRender?: boolean;
    api?: (context: ChessboardAPI.Context) => any;
    apiOverrides?: Record<string, PluginOverride>;
    /**
     * The list of { condition, handler } pairs
     * to run before event will be passed to the chain of plugins.
     *
     * If any of those handlers will return `false`, state will not
     * be attached to the event payload.
     */
    beforeState?: BeforeState[];
    create?: (context: Core.Context) => any;
    destroy?: Destroy;
    destroyAPIMethods?: Function;
    destroyAPIOverrides?: Function;
    destroyModeOverrides?: Function;
    isCore?: boolean;
    match?: Match[];
    modeOverrides?: Modes.API.Extension;
    name: string;
    requires?: string[];
  }
}
